// Module
var code = "<template>\r\n\r\n\t<!--Main layout-->\r\n\t<main id=\"rma_main\">\r\n\t\t<iframe id=\"rma_iframe\" src=\"/dist/assets/pdf/FR RMA.pdf\"></iframe>\r\n\t</main>\r\n\t<!--Main layout-->\r\n\r\n</template>";
// Exports
module.exports = code;